module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/bicyclo-736ea4a2a7b3e5ff935a9620d461f31d.png";